import { z } from 'zod';
import { passwordIsStrong } from '@/features/auth/password';

export const forgotPasswordSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Enter a valid email.'),
});
export type ForgotPasswordForm = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z
  .object({
    new_password: z.string().refine(passwordIsStrong, {
      message: 'Password must meet every rule below (12+ chars, upper, lower, number, special).',
    }),
    confirm_password: z.string().min(1, 'Confirm your new password.'),
  })
  .refine((d) => d.new_password === d.confirm_password, {
    message: 'Passwords do not match.',
    path: ['confirm_password'],
  });
export type ResetPasswordForm = z.infer<typeof resetPasswordSchema>;
